import ReactDOM from 'react-dom'

import './index.css'
import App from './App'
 
// Register service worker for offline-first (production only)

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((v) => {
      console.log('Service worker registration successful', v)
    }).catch((err) => {
      console.log('Service worker registration failed', err)
    })  
  })
} else if (process.env.NODE_ENV !== 'production') {
  console.log('Service worker disabled in development mode')
} else {
  console.log('Service worker not supported')
}

ReactDOM.render(<App />,document.getElementById('root'))
